import * as types from "../../mutation-types"
import axios from "axios"
import api from "../../../api"
import jsonApii from "../../../helpers/json_apii"


// initial state
const state = {
  moodleCategories : [],
}

// getters
const getters = {
  moodleCategories: state => state.moodleCategories,
  moodleCategoriesByParentId: state => parentId => {
    return state.moodleCategories.filter(c => c.parent_id === parentId)
  },
  moodleCategoriesTree: (state, getters) => {
    const categories = getters.moodleCategoriesByParentId(0)

    return categories.map(category => {
      return {
        ...category,
        children: [...getters.moodleCategoriesByParentId(category.id)],
      }
    })

  },
}

// actions
const actions = {
  fetchMoodleCategories({ commit }) {
    axios.get(api.v1.moodleCategoriesUrl()
    )
      .then( responce => {
        commit(types.UPDATE_MOODLE_CATEGORIES, jsonApii.getData(responce.data))
      })
  },
}

// mutations
const mutations = {
  [types.UPDATE_MOODLE_CATEGORIES](state, categories){
    state.moodleCategories = categories
  },

}

export default {
  state,
  getters,
  actions,
  mutations,
}
